import {createSelector} from '@ngrx/store';
import {AppState} from '../../interfaces/app-state.interface';


export class DeleteDialogSelectors {

  private static selectDeleteDialog = (state: AppState) => state.deleteDialog;

  public static isOpen = createSelector(
    this.selectDeleteDialog,
    deleteDialog => deleteDialog?.isOpen ?? false,
  );

  public static document = createSelector(
    this.selectDeleteDialog,
    deleteDialog => deleteDialog?.document ?? null,
  );

  public static isDeleting = createSelector(
    this.selectDeleteDialog,
    deleteDialog => deleteDialog?.isDeleting ?? false,
  );
}
